import { defineMessages } from 'react-intl-next';

export const macroI18n = defineMessages({
	noQuestionsFound: {
		id: 'questions.list.noQuestionsFound',
		defaultMessage: 'No questions found',
		description: 'Message displayed when there are no questions to show',
	},
});
